import styled from 'styled-components';

export const SensorPanelsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
  width: 100%;
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0; /* Prevents overflow issues */
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0; /* Prevents overflow issues */
`;

export const SensorPanel = styled.div`
  background-color: #2a2a2a;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #404040;
  min-width: 0; /* Prevents content overflow */
  overflow: hidden; /* Ensures content stays within bounds */
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #404040;
`;

export const PanelIcon = styled.div`
  color: #0066cc;
`;

export const PanelTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #ffffff;
`;

export const SensorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SensorRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #333;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const SensorLabel = styled.div`
  font-size: 14px;
  color: #ccc;
  flex: 1;
`;

export const SensorValue = styled.div<{ status?: 'normal' | 'warning' | 'critical' | 'inactive' }>`
  font-size: 14px;
  font-weight: 600;
  font-family: 'SF Mono', Consolas, monospace;
  
  ${props => {
    switch (props.status) {
      case 'critical':
        return 'color: #ef4444;';
      case 'warning':
        return 'color: #f59e0b;';
      case 'normal':
        return 'color: #10b981;';
      case 'inactive':
        return 'color: #6b7280;';
      default:
        return 'color: #ffffff;';
    }
  }}
`;

export const MapContainer = styled.div`
  background-color: #1a1a1a;
  border-radius: 8px;
  height: 400px;
  position: relative;
  overflow: hidden;
  border: 1px solid #404040;
`;

export const MapContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  position: relative;
`;

export const CoordinatesDisplay = styled.div`
  background-color: rgba(0, 102, 204, 0.1);
  border: 1px solid #0066cc;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  margin: 20px;
`;

export const CoordinatesTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
`;

export const CoordinatesValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #0066cc;
  font-family: 'SF Mono', Consolas, monospace;
  margin-bottom: 8px;
`;

export const MapNote = styled.div`
  font-size: 12px;
  color: #888;
  font-style: italic;
`;

export const TrackingInfo = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: rgba(42, 42, 42, 0.9);
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #404040;
`;

export const TrackingLabel = styled.div`
  font-size: 12px;
  color: #888;
  margin-bottom: 4px;
`;

export const TrackingValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
`;

export const MapActions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
`;

export const MapButton = styled.button`
  background-color: #0066cc;
  border: none;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  
  &:hover {
    background-color: #0052a3;
  }
`;

export const ExportButton = styled.button`
  background-color: #0066cc;
  border: none;
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background-color: #0052a3;
  }
`;
